import { render, staticRenderFns } from "./AccreditationDetail.vue?vue&type=template&id=220d4570&scoped=true"
import script from "./AccreditationDetail.vue?vue&type=script&lang=js"
export * from "./AccreditationDetail.vue?vue&type=script&lang=js"
import style0 from "./AccreditationDetail.vue?vue&type=style&index=0&id=220d4570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d4570",
  null
  
)

export default component.exports